// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixWindow from 'wix-window';
// import {session} from 'wix-storage';
// import wixLocation from 'wix-location';
// let previousPageURL;

$w.onReady(function () {
	$w("#biglogo").hide();
	 $w("#logosmall").show();
	// previousPageURL = session.getItem("page");
	// console.log(previousPageURL);
});


//  export function btnBack_click(event) {
// 	wixLocation.to((previousPageURL).toString());
//  }


